import React, { useMemo } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input } from 'reactstrap';
import { ORDER_NUMBER_REGEX, TITLE_TR_REGEX } from '../../../../_helper/regexHandler';
import { useModalCrudState } from '../../../../_helper/hooks/useModalCrudState';

const CityDataModal = ({ apiEndpoint, isOpen, toggle, mode, selectedCity, refreshData }) => {
    const initialCityData = {
        id: '',
        title: '',
        order: '',
        district: [''],
    };

    const validationSchema = useMemo(() => ({
        title: {
            required: true,
            message: 'Şehir adı zorunludur.',
            regex: TITLE_TR_REGEX,
            regexMessage: 'Şehir adı sadece harf ve boşluk içerebilir minimum 3 karakter maksimum 50 karakter desteklemektedir.',
        },
        order: {
            required: true,
            message: 'Sıra numarası zorunludur.',
            regex: ORDER_NUMBER_REGEX,
            regexMessage: 'Sıra numarası sadece rakam içermelidir.',
        },
    }), []);

    const {
        formData: cityData,
        errors,
        handleCancel,
        handleInputChange,
        handleSubmit,
        isSubmitting,
    } = useModalCrudState({
        isOpen,
        mode,
        selectedItem: selectedCity,
        initialData: initialCityData,
        toggle,
        normalizeInput: true,
        validationSchema,
        submitConfig: {
            apiEndpoint,
            refreshData,
            componentName: 'Şehir',
        },
    });

    const getModalTitle = () => {
        return mode === 'add' ? 'Şehir Ekle' : 'Şehir Düzenle';
    };

    const getButtonLabel = () => {
        return mode === 'add' ? 'Ekle' : 'Güncelle';
    };

    return (
        <Modal isOpen={isOpen} toggle={handleCancel}>
            <ModalHeader toggle={handleCancel}>{getModalTitle()}</ModalHeader>
            <ModalBody>
                <Form>
                    <FormGroup>
                        <Label for="order">Sıra <span className="text-danger">*</span></Label>
                        <Input
                            type="text"
                            id="order"
                            name="order"
                            value={cityData.order}
                            onChange={handleInputChange}
                            invalid={!!errors.order}
                        />
                        {errors.order && <div className="text-danger small mt-1">{errors.order}</div>}
                    </FormGroup>
                    <FormGroup>
                        <Label for="title">Şehir Adı <span className="text-danger">*</span></Label>
                        <Input
                            type="text"
                            id="title"
                            name="title"
                            value={cityData.title}
                            onChange={handleInputChange}
                            invalid={!!errors.title}
                        />
                        {errors.title && <div className="text-danger small mt-1">{errors.title}</div>}
                    </FormGroup>
                </Form>
            </ModalBody>
            <ModalFooter>
                <button className="btn btn-outline-success rounded-pill" onClick={handleSubmit} disabled={isSubmitting}>
                    {isSubmitting ? 'Kaydediliyor...' : getButtonLabel()}
                </button>
                <button className="btn btn-outline-danger rounded-pill" onClick={handleCancel}>
                    İptal
                </button>
            </ModalFooter>
        </Modal>
    );
};

export default CityDataModal;
